import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/editor/selectableSection.sss';

const simpleDomProps = new Set(['style', 'id', 'disabled']);

export default class SelectableSection extends Component {
	getPassthroughProps(props = this.props) {
		return Object.fromEntries(
			Object.entries(props).filter(([k]) =>
				k.startsWith('data-')
				|| /^on[A-Z]/.test(k)
				|| simpleDomProps.has(k)
			)
		);
	}

	render(props) {
		const { section, activeElement, children } = props;
		const rest = this.getPassthroughProps(props);
		return (
			<button data-section={section} class={joinClasses(props.class, s.section, !props.noOutline && section === activeElement && s.active)} {...rest}>
				{children}
			</button>
		);
	}
}